import { IMenuSettings } from '@/library/MenuSettingsHelper';
import { ITourPageSettings } from '@/library/TourPageSettingsHelper';
import { IModuleSettings } from '@/library/ModuleSettingsHelper';
import { ITourContractSettings } from '@/library/ContractSettingsHelper';
import { ITourPlayerSettings } from '@/library/TourPlayerSettingsHelper';
import { ITourBagSettings } from '@/library/TourBagSettingsHelper';
import type { OrderSettings } from '@/api/models/OrderSettings';
//import { IOrdersReportsSettings } from '@/library/OrdersReportSettingsHelper';

export default class UserSessionModel {
  id: string = ''; // could be the user's ID or email
  name: string = '';
  email: string = '';
  token: string = '';
  timestamp: Date = new Date();

  // User info
  appUserId?: number;
  subnavOrder?: string;
  orderSettings?: OrderSettings | null;

  // Permissions
  menuSettings?: IMenuSettings;
  tourReportSettings?: Record<string, boolean>;
  tourPageSettings?: ITourPageSettings;
  moduleSettings?: IModuleSettings;
  contractSettings?: ITourContractSettings;
  tourPlayerSettings?: ITourPlayerSettings;
  tourBagSettings?: ITourBagSettings;
  ordersReportSettings?: Record<string, boolean>;
}
